module.exports = __webpack_public_path__ + "static/media/abhishek.f4cf3fbb.jpg";